import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { DocumentTypesEnum } from '../../../document-data/document-data.data';

export const DOCUMENT_NOTES_SCHEMA = Object.freeze({
  USE_DEFAULT: true,
  DEFAULT: '',
  INVOICE: '',
  ESTIMATE: '',
  CREDIT_MEMO: '',
  PURCHASE_ORDER: '',
});
const RECORD = generateSchema(DOCUMENT_NOTES_SCHEMA);
const KEYS: any = generateKeys(DOCUMENT_NOTES_SCHEMA);

export class DocumentNotes extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get useDefault(): boolean {
    return this.get(KEYS.USE_DEFAULT);
  }

  get defaultNotes(): string {
    return this.get(KEYS.DEFAULT);
  }

  get invoiceNotes(): string {
    return this.get(KEYS.INVOICE);
  }

  get estimateNotes(): string {
    return this.get(KEYS.ESTIMATE);
  }

  get purchaseOrderNotes(): string {
    return this.get(KEYS.PURCHASE_ORDER);
  }

  get creditMemoNotes(): string {
    return this.get(KEYS.CREDIT_MEMO);
  }

  noteFor(documentType: DocumentTypesEnum): string {
    return this.get(KEYS[documentType.toUpperCase()]);
  }
}
